import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

type ContainerProps = {
  $isActive: boolean;
};

export const Container = styled.button<ContainerProps>`
  padding-block: 8px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 500;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
  text-transform: uppercase;

  border-radius: 4px;

  background-color: ${props => (props.$isActive ? "#30343C" : "#A1A1A1")};

  cursor: pointer;
`;
